export class FileContent {

  constructor(
    public file: Blob,
    public name: string
  ) { }

}
